import imageCompression from 'browser-image-compression';

/**
 * Client-side compression before upload (PRD §8.4). This guarantees a sane
 * upload size from any phone; the Storage Cloud Function (sharp) then does a
 * second, authoritative pass + thumbnail (decision #5, defense-in-depth).
 */
export async function compressImage(file: File): Promise<File> {
  return imageCompression(file, {
    maxSizeMB: 1.2,
    maxWidthOrHeight: 1600,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.8,
  });
}
